import './DialogAjouterDiplome.scss';

import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {
    Button,
    Checkbox,
    Dialog,
    FormControlLabel,
    IconButton,
    ThemeProvider,
} from '@mui/material';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { secteurActiviteEnum } from '../../data/Interfaces';
import useDateRangeValidator from '../../hooks/useDateRangeValidator';
import useFormValidation, { champRequisString, isErrorObjectClean } from '../../hooks/useFormValidation';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { FieldComponentFont } from '../../Styles/componentStyles';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import QuillAdvancedTextArea from '../shared/QuillAdvancedTextArea';
import {
    DatePickerComponent,
    SelectComponent,
    TextFieldComponent,
    Transition,
} from '../shared/ReusableSmallComponents';
import SearchCity from '../shared/SearchCity';

function DialogAjouterExperience({
    open,
    handleClose,
    experiences,
    setExperiences,
    experienceIndex,
    setExperienceIndex,
}) {
    DialogAjouterExperience.propTypes = {
        open: PropTypes.any,
        experiences: PropTypes.any,
        handleClose: PropTypes.func,
        setExperiences: PropTypes.func,
        experienceIndex: PropTypes.any,
        setExperienceIndex: PropTypes.func,
    };

    const { setShowErrors, setErrors, errors } = useUtilities();
    //const [typeContrat, setTypeContrat] = useState();
    const [secteur, setSecteur] = useState();
    const [intitulePoste, setIntitulePoste] = useState('');
    const [description, setDescription] = useState();
    const [entreprise, setEntreprise] = useState('');
    const [dateDebut, setDateDebut] = useState(null);
    const [dateFin, setDateFin] = useState(null);
    const [isEncours, setIsEncours] = useState(false);
    const [localisation, setLocalisation] = useState();
    const {device}=useWindowSize();
    const [visibilityEnCoursChamps, setVisibilityEnCoursChamps] = useState();
    const [visibilityDateFin, setVisibilityDateFin] = useState(false);
    const { i18n } = useTranslation();
    const [isValidRangeDateExperience, messageRangeDateExperience] =
        useDateRangeValidator(dateDebut, dateFin);
    //TODO add proper naming + submit form
    const [isValid] = useFormValidation([
        { name: 'intitulePoste', value: intitulePoste },
        { name: 'description', value: description },
        { name: 'entreprise', value: entreprise },
        { name: 'dateDebut', value: dateDebut },
        { name: 'dateFin', value: dateFin },
        // { name: 'typeContrat', value: typeContrat },
        // { name: 'localisation', value: localisation },
    ]);
    useEffect(() => {
        checkDateDebDateFin();
    }, [dateFin]);

    useEffect(() => {
        console.log(
            'experienceIndex experienceIndexexperienceIndex',
            experienceIndex
        );
        if (experienceIndex || experienceIndex == 0) {
            console.log('index', experienceIndex);
            setIntitulePoste(experiences[experienceIndex]?.intitulePoste);
            //setTypeContrat(experiences[experienceIndex]?.typeContrat);
            setDescription(experiences[experienceIndex]?.description);
            setLocalisation(experiences[experienceIndex]?.localisation);
            setDateFin(experiences[experienceIndex]?.dateFin);
            setDateDebut(experiences[experienceIndex]?.dateDebut);
            setEntreprise(experiences[experienceIndex]?.entreprise);
            setSecteur(experiences[experienceIndex]?.secteurActivite);
            setIsEncours(experiences[experienceIndex]?.isEncours); //a voir avec reda le button current dans experience et diplome
            if (experiences[experienceIndex]?.isEncours) setVisibilityDateFin(true);
        }
    }, [experienceIndex]);

    const AddExperience = async () => {
        let experienceToAdd = {
            intitulePoste: intitulePoste,
            localisation: localisation,
            secteurActivite: secteur,
            entreprise: entreprise,
            description: description,
            dateDebut: dateDebut,
            //typeContrat: typeContrat,
        };
        if(isEncours){
            experienceToAdd = {...experienceToAdd, isEncours};
        }
        else{
            experienceToAdd = {...experienceToAdd,
                dateFin: dateFin};
        }
        console.log(experienceToAdd);
        if (experienceIndex >= 0) {
            const list = [...experiences];
            list.splice(experienceIndex, 1,experienceToAdd);
            setExperiences(list);
            resetDataAndClose();
        } else {
            const list = [...experiences];
            list.push(experienceToAdd);
            console.log('list', list);
            setExperiences(list);
            resetDataAndClose();
        }
    };

    const SupprimerExperience = () => {
        if (experienceIndex >= 0) {
            const list = [...experiences];
            list.splice(experienceIndex, 1);
            setExperiences(list);
            resetDataAndClose();
        }
    };

    const resetDataAndClose = () => {
        setIntitulePoste('');
        setDescription('');
        setEntreprise('');
        setDateDebut(null);
        setDateFin(null);
        setLocalisation();
        setSecteur(null);
        //setTypeContrat(null);
        setIsEncours(false);
        setVisibilityDateFin(false);
        setExperienceIndex();
        handleClose();
    };

    const checkDateDebDateFin = () => {
        if (!dateFin) {
            setVisibilityEnCoursChamps(false);
        } else {
            setVisibilityEnCoursChamps(true);
        }
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={resetDataAndClose}
                fullScreen
                TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        background: '#FFFFFF',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '24px',
                    },
                }}
            >
                <div className="frame00FicheCollab">
                    <div className="frame01FicheCollab">
                        <IconButton onClick={resetDataAndClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>

                <div className="AjouterDiplomeFrame0">
                    <div className="AjouterDiplomeFrame2">
                        <h4 className="titlesociete">{i18n.t('Ajouter une expérience')}</h4>
                        <div className="AjouterDiplomeFrame3">
                            <h6 className="AjouterDiplomeFrame4">
                                {i18n.t('Mission et responsabilités')}
                            </h6>
                            <div className="AjouterDiplomeFrame5">
                                <div className="AjouterDiplomeFrame6">
                                    <label className="AjouterDiplomeFrame7">
                                        {i18n.t('Intitulé du poste*')}
                                    </label>
                                    <div className="AjouterDiplomeFrame8">
                                        <TextFieldComponent
                                            id="margin-none"
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                            name="intitulePoste"
                                            value={intitulePoste}
                                            onChange={(e) => {
                                                setIntitulePoste(e.target.value);
                                            }}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </div>

                                {/*<div className="AjouterDiplomeFrame6">

                                    <SelectComponent
                                        label={' de contrat *'}
                                        name='typeContrat'
                                        val={typeContrat}
                                        setVal={(e) => {
                                            setTypeContrat(e.target.value);
                                        }}
                                        listVal={typesContratEnum}
                                    />
                                </div>*/}
                                <div
                                    className="AjouterDiplomeFrame6"
                                    style={{ flexDirection: 'row' }}
                                >
                                    <QuillAdvancedTextArea
                                        value={description ?? ''}
                                        // ? si le backOffice la modifie, une notification envoyee a le sera suffisante
                                        //! placeholder="Description (facultatif)" ! puisque c'est dans la liste required, donc c'est pas facultative ..
                                        placeholder={i18n.t('Description')}
                                        name='description'
                                        setValue={setDescription}
                                        style={{
                                            width: '100%',
                                        }}
                                    />
                                </div>
                            </div>
                            <h6 className="AjouterDiplomeFrame4">{i18n.t('Entreprise')}</h6>
                            <div className="AjouterDiplomeFrame5">
                                <div className="AjouterDiplomeFrame6">
                                    <label className="AjouterDiplomeFrame7">
                                        {i18n.t('Nom d\'entreprise *')}
                                    </label>
                                    <div className="AjouterDiplomeFrame8">
                                        <TextFieldComponent
                                            id="margin-none"
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                            name='entreprise'
                                            value={entreprise}
                                            onChange={(e) => {
                                                setEntreprise(e.target.value);
                                            }}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </div>
                                <SelectComponent
                                    label={i18n.t('Secteur d\'activité de l\'entreprise (facultatif)')}
                                    val={secteur}
                                    setVal={(e) => {
                                        setSecteur(e.target.value);
                                    }}
                                    listVal={secteurActiviteEnum}
                                />
                                <div className='AjouterDiplomeFrame9'>
                                    <SearchCity
                                        setCity={setLocalisation}
                                        city={localisation}
                                        label={i18n.t('Ville')}
                                        name='localisation'
                                        width={'100%'}
                                    />
                                </div>
                            </div>
                            <h6 className="AjouterDiplomeFrame4">{i18n.t('Durée')}</h6>
                            <div className="AjouterDiplomeFrame13">
                                <div className="AjouterDiplomeFrame14">
                                    <label className="AjouterDiplomeFrame7">{i18n.t('De*')}</label>
                                    <div className="AjouterDiplomeFrame8">
                                        <DatePickerComponent
                                            views={['year', 'month']}
                                            width={'100%'}
                                            date={dateDebut}
                                            name='dateDebut'
                                            setDate={(newValue) => {
                                                setDateDebut(newValue);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="AjouterDiplomeFrame14">
                                    <label className="AjouterDiplomeFrame7">{i18n.t('Au*')}</label>
                                    <div className="AjouterDiplomeFrame8">
                                        <DatePickerComponent
                                            views={['year', 'month']}
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                            disabled={visibilityDateFin}
                                            name='dateFin'
                                            date={visibilityDateFin ? null : dateFin}
                                            setDate={(newValue) => {
                                                setDateFin(newValue);
                                            }}
                                            width={'100%'}
                                            error={isValidRangeDateExperience &&!!messageRangeDateExperience}
                                            helperText={isValidRangeDateExperience  ? messageRangeDateExperience: null}
                                        />
                                    </div>
                                </div>
                            </div>
                            <ThemeProvider theme={FieldComponentFont}>
                                <FormControlLabel
                                    control={<Checkbox />}
                                    disabled={visibilityEnCoursChamps}
                                    checked={isEncours}
                                    label={i18n.t('Jusqu\'à aujourd\'hui')}
                                    onChange={() => {
                                        setIsEncours(!isEncours);
                                        if (!isEncours) {
                                            setDateFin(null);
                                            setErrors({ ...errors, ...{ dateFin: '' } });
                                            setVisibilityDateFin(true);
                                        } else {
                                            setVisibilityDateFin(false);
                                            if(dateFin == null || dateFin == '')
                                                setErrors({ ...errors, ...{ dateFin: champRequisString } });
                                        }
                                    }}
                                />
                            </ThemeProvider>
                        </div>
                        <div className="AjouterDiplomeFrame11">
                            <Button
                                variant="text"
                                startIcon={<DeleteForeverIcon />}
                                //color="error"
                                style={{...buttonStyles(),...{color:'#EC5B56'}}}
                                onClick={() => {
                                    SupprimerExperience();
                                }}
                            >
                                {i18n.t('Supprimer')}
                            </Button>
                            <div className="AjouterDiplomeFrame12">
                                <Button
                                    variant="text"
                                    style={{...buttonStyles(),...{width:'100%',order:device=='desktop'?'0':'1'}}}
                                    onClick={() => {
                                        resetDataAndClose();
                                    }}
                                >
                                    {i18n.t('Annuler')}
                                </Button>
                                <Button
                                    variant="contained"
                                    style={{...buttonStylesGreen((isValidRangeDateExperience && !!messageRangeDateExperience)),...{width:'100%',order:device=='desktop'?'1':'0'}}}
                                    disabled={
                                        isValidRangeDateExperience && !!messageRangeDateExperience
                                    }
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (isValid ||  isErrorObjectClean({ ...errors, ...{ dateFin: '' } })) {
                                            AddExperience();
                                            resetDataAndClose();
                                            setShowErrors(false);
                                            setErrors({});
                                        }
                                        else setShowErrors(true);
                                    }}
                                >
                                    {i18n.t('Valider')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
}

export default DialogAjouterExperience;
